import Setting from './setting.vue'
export default Setting
